import { cn } from '~/shared/lib/cn'
import { SkeletonBlock } from '~/shared/ui/skeleton-block'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '~/shared/ui/table'

interface DataTableProps {
  columnsCount: number
  rowsCount: number
  containerClassName?: string
  withStickyHeader?: boolean
  footer?: React.ReactNode
}

export function DataTableLoadingSkeleton({
  columnsCount,
  rowsCount,
  containerClassName,
  withStickyHeader,
  footer,
}: DataTableProps) {
  return (
    <Table
      containerClassName={containerClassName}
      footer={footer}
    >
      <TableHeader
        className={cn({
          'sticky top-0 z-1': withStickyHeader,
        })}
      >
        <TableRow>
          {[...Array(columnsCount)].map((_, j) => {
            return (
              <TableHead
                key={j}
                className="first:pl-4 last:pr-4"
              >
                <SkeletonBlock className="h-5.5" />
              </TableHead>
            )
          })}
        </TableRow>
      </TableHeader>
      <TableBody className="[&_tr]:hover:bg-unset [&_tr]:cursor-default">
        {[...Array(rowsCount)].map((_, i) => (
          <TableRow key={i}>
            {[...Array(columnsCount)].map((_, j) => (
              <TableCell
                key={j}
                className="h-[61px] first:pl-4 last:pr-4"
              >
                <SkeletonBlock className="h-5.5" />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
